import { render, staticRenderFns } from "./_announcement_create_form.vue?vue&type=template&id=80904084"
import script from "./_announcement_create_form.vue?vue&type=script&lang=js"
export * from "./_announcement_create_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports